module.exports = __webpack_public_path__ + "media/images/SF_logo_crest-0c63927836169226a682339512c16a3d.png";